import axios, { AxiosResponse } from 'axios'

import { env } from '@js/utils/env'
import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'
import { cartFragment } from '@js/api/fragments/cartFragment'

import { Cart } from '@js/api/types/cart/Cart'

interface RemoveCouponFromCartResponse {
  data: {
    removeCouponFromCart: {
      cart: Cart
    } | null
  }
  errors?: [{ message: string }]
}

export const removeCouponFromCartMutation = gql`
  mutation($cartId: String!) {
    removeCouponFromCart(input: { cart_id: $cartId }) {
      cart {
        ...CartDetails
      }
    }
  }
  ${cartFragment}
`

/**
 * @throws {string}
 *
 * Will throw one error message; Magento only returns one at a time, rather than an array of all errors.
 */
export const removeCouponFromCart = async (
  payload: { cartId: string }
): Promise<Cart | null> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<RemoveCouponFromCartResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName(),
    },
    data: {
      query: removeCouponFromCartMutation,
      variables: {
        cartId: payload.cartId,
      },
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  if (data.data.removeCouponFromCart) {
    return data.data.removeCouponFromCart.cart
  }

  return null
}